import { Icon } from '@app/models/commons.model';
import { SvgIconRegistryService } from 'angular-svg-icon';

export const iconsInitializer = (
  iconReg: SvgIconRegistryService,
  icons: Icon[],
): (() => void) => {
  return () => {
    icons.forEach((icon) => iconReg.loadSvg(icon.path, icon.name)?.subscribe());
  };
};
